<template>
  <div class="credit-container">
    <top></top>
    <van-list v-if="list.length" v-model="loading" :finished="finished" finished-text="没有更多了" @load="getList" class="log-wrapper">
      <div class="log-item" v-for="item in list" :key="item.id">
        <!-- <p>{{item.event}}<span>{{item.credit}}</span>金币</p> -->
        <div class="left">
          <p>{{item.remark}}</p>
          <span>{{item.created | timeParse}}</span>
        </div>
        <div></div>
      </div>
    </van-list>
    <div v-else class="blank-content">
      <p class="blank-title">没找到{{userInfo.app.credit_alias}}记录</p>
      <p class="blank-desc">亲爱的用户您没有任何{{userInfo.app.credit_alias}}记录</p>
      <button @click="toIndex" class="blank-btn">去主页看看</button>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import top from '@/components/top'
import { List } from 'vant'
import { mapGetters } from 'vuex'
Vue.use(List)

export default {
  name: 'CreditLog',
  components: { top },
  data() {
    return {
      list: [],
      loading: false,
      finished: false,
      next: '/credit/log/?limit=10'
    }
  },
  computed: {
    ...mapGetters(['userInfo'])
  },
  filters: {
    timeParse(time) {
      const dateArr = time.split('T')
      const timeArr = dateArr[1].split('.')
      return dateArr[0] + ' ' + timeArr[0]
    }
  },
  created() {
    this.getList()
  },
  methods: {
    getList() {
      var that = this
      this.axios.get(this.next).then(function(res) {
        that.list = that.list.concat(res.data.results)
        that.loading = false
        if (res.data.next) {
          that.next = res.data.next
        } else {
          that.finished = true
        }
      }).catch(function(error) {
        console.log(error)
      })
    },
    /**
     * 去首页
     */
    toIndex() {
      this.$router.replace({ path: '/' })
    }
  }
}
</script>

<style lang="scss" scoped>
.log-wrapper{
  margin-top: 60px;
  .log-item{
    width: 345px;
    height: 70px;
    padding: 0 15px;
    background-color: #ffffff;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 0 auto 1px;
    .left{
      height: 50px;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      p{
        width: 330px;
        color: #4a4a4a;
        font-size: 14px;
        font-weight: 400;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
        span{
          color: #f5a623;
          font-size: 14px;
          font-weight: 600;
        }
      }
      span{
        color: #aaaaaa;
        font-size: 12px;
        font-weight: 400;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/user/credit/log.vue